import styled from "styled-components";
import {BodyText, Label, Subtitle} from "../../typography";
import {ToggleButton} from "../../toggleButton";
import {mediaQuery} from "../../../utils";

export const AccessibilityWindowContainer = styled.div`
    min-width: 500px;
    min-height: 450px;
    background-color: ${({theme}) => theme.colors.primaryW};
    position: absolute;
    bottom: 15px;
    right: 15px;
    box-shadow: 0 1px 10px #a7a7a7, inset 0 0 0 #fff;
    border-radius: 0.4rem;
    word-spacing: var(--word-spacing);
`;

export const StyledTitle = styled(Subtitle)`
    color: ${({theme}) => theme.colors.primaryK10};
    line-height: var(--h3-line-height);
`;

export const StyledText = styled(BodyText)`
    color: ${({theme}) => theme.colors.primaryK10};
    line-height: var(--h5-line-height);
    display: flex;
    text-align: start;
`;

export const StyledLabel = styled(BodyText)`
    color: ${({theme}) => theme.colors.primaryK7};
    display: flex;
    justify-content: start;
    padding: 20px 15px 10px 15px;
    line-height: var(--h5-line-height);
`;

export const StyledTitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: #f5f5f5 1px solid;
    padding: 10px 15px;
`;

export const StyledToggleContainer = styled.div`
    & > div > p {
      margin: 0;
      font-size: var(--main-font-size);
    }
  margin-bottom: 10px;
`;


export const StyledContentContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 15px 15px 0 15px;
`;

export const StyledToggleButton = styled(ToggleButton)`
    height: 17px;
    width: 17px;
    & > * {
        height: 17px;
        width: 17px;
    }
`;

export const SubmenuContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: 0.625rem;
    padding-bottom: 1.2rem;
    min-height: 1.5rem;
    justify-content: center;
    align-items: center;
`;

export const SubmenuItemContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    max-width: 40rem;

    width: 100%;
    gap: 1rem;
`;

export const SliderBodyContainer  = styled.div`
    width: 90%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    padding-left: 25px;
`;

export const StyledSubmenuItem = styled(Label)<{ selected?: boolean }>`
  font-size: var(--h3-font-size);
  text-transform: none;
  border-bottom: solid 3px transparent;
  margin-bottom: 2rem;
  line-height: 1.5rem !important;
  // On mobile screens, submenu has a dark theme.
  color: ${({theme}) => theme.colors.primaryK3};

  cursor: pointer;

  ${mediaQuery('md')} {
    color: ${({theme}) => theme.colors.primaryK10};
    margin-bottom: 0;
    text-transform: uppercase;
    font-size: var(--h5-font-size);
    transition: border-bottom 0.15s linear;
    line-height: var(--h5-line-height);
    padding: 0rem 1rem 0rem 1rem;

    ${(props) =>
    props.selected &&
    ` color: ${props.theme.colors.primaryT2};
        border-bottom: solid 3px ${props.theme.colors.primaryT2};
    `}

    &:hover {
      color: ${({theme}) => theme.colors.primaryK7};
    }
    ${(props) =>
    props.selected &&
    `
        &:hover {
          color: ${props.theme.colors.primaryT1} ;
          border-bottom: solid 3px ${props.theme.colors.primaryT1} 
        }
      `}
  }
`;